module.exports = __webpack_public_path__ + "img/Google.574005fa.svg";